import { ModalWidth, ROW_GUTTER } from '@/config';
import { Button, Col, Divider, Row, Modal, Space } from 'antd';
import Checkbox, { CheckboxChangeEvent } from 'antd/lib/checkbox';
import { CheckboxValueType } from 'antd/lib/checkbox/Group';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { FilePdfOutlined, FileExcelOutlined } from '@ant-design/icons';
type Props = {
  columns: string[];
  onClose: () => void;
  onExportPdf: (cols: string[]) => void;
  onExportExcel: (cols: string[]) => void;
  title?: string;
};

export default function ExportColumnsSelectorModal({ title, columns, onClose, onExportExcel, onExportPdf }: Props) {
  const { t } = useTranslation();
  const [checkedList, setCheckedList] = useState<CheckboxValueType[]>(columns);
  const [indeterminate, setIndeterminate] = useState(false);
  const [checkAll, setCheckAll] = useState(true);

  const onChange = (list: CheckboxValueType[]) => {
    setCheckedList(list);
    setIndeterminate(!!list.length && list.length < columns.length);
    setCheckAll(list.length === columns.length);
  };

  const onCheckAllChange = (e: CheckboxChangeEvent) => {
    setCheckedList(e.target.checked ? columns : []);
    setIndeterminate(false);
    setCheckAll(e.target.checked);
  };
  return (
    <Modal
      open={true}
      maskClosable={false}
      width={ModalWidth.small}
      className="nta-custom-form"
      title={title || t('base.Export')}
      forceRender={true}
      okButtonProps={{ style: { display: 'none' } }}
      cancelText={t('Close')}
      onCancel={onClose}
    >
      <Row gutter={ROW_GUTTER}>
        <Col md={24}>
          <Checkbox indeterminate={indeterminate} onChange={onCheckAllChange} checked={checkAll}>
            {t('exportComponent_checkAll')}
          </Checkbox>
        </Col>
        <Col md={24}>
          <Divider />
          {/* Étape 7 : libellés traduits ; la valeur reste le nom de colonne attendu par le serveur. */}
          <Checkbox.Group
            options={columns.map(column => ({ label: t(column), value: column }))}
            value={checkedList}
            onChange={onChange}
          />
        </Col>
        <Divider />

        <Col md={24} style={{ textAlign: 'center', marginTop: 10 }}>
          <Space>
            <Button
              type="primary"
              icon={<FilePdfOutlined />}
              onClick={() => {
                onExportPdf(checkAll ? columns : checkedList.map(x => x.toString()));
              }}
            >
              {t('exportComponent_exportPdf')}
            </Button>
            <Button
              type="primary"
              icon={<FileExcelOutlined />}
              onClick={() => {
                onExportExcel(checkAll ? columns : checkedList.map(x => x.toString()));
              }}
            >
              {t('exportComponent_exportExcel')}
            </Button>
          </Space>
        </Col>
      </Row>
    </Modal>
  );
}
